import {useCallback, useState} from 'react';

/**
 * Custom hook for the `SearchInput` component.
 * Manages focus state for styling the focus ring.
 *
 * @returns An object containing:
 * - `isFocused`: Whether the input is currently focused.
 * - `handleBlur`: Callback to clear focus state.
 * - `handleFocus`: Callback to set focus state.
 *
 * @example
 * ```tsx
 * const {handleBlur, handleFocus, isFocused} = useSearchInput();
 * ```
 */
export const useSearchInput = () => {
    const [isFocused, setIsFocused] = useState(false);

    /** Sets the focus state to true. */
    const handleFocus = useCallback(() => {
        setIsFocused(true);
    }, []);

    /** Sets the focus state to false. */
    const handleBlur = useCallback(() => {
        setIsFocused(false);
    }, []);

    return {
        handleBlur,
        handleFocus,
        isFocused
    };
};